import getYouTubeId from 'get-youtube-id';
import YoutubePlayer from 'components/media/youtube-player';

const PTYoutubePlayer = (node) => {
	const { url, autoplay, loop, controls } = node.value;
	const id = getYouTubeId(url);

	//Clip is the only url param option we support for rich text at the mmoment.
	const urlParams = new URLSearchParams(url?.split('?')?.[1]);
	const clip = urlParams.get('clip');
	const clipt = urlParams.get('clipt');

	return (
		<YoutubePlayer
			clip={clip}
			clipt={clipt}
			youtubeId={id}
			autoplay={autoplay}
			loop={loop}
			controls={controls}
		/>
	);
};

export default PTYoutubePlayer;
